import { SvgComponent } from '@tager/web-components';

import { ReactComponent as TwitterIcon } from '@/assets/svg/social/twitter-share.svg';
import { ReactComponent as FacebookIcon } from '@/assets/svg/social/facebook-share.svg';
import { ReactComponent as VkIcon } from '@/assets/svg/social/vk-share.svg';
import { ReactComponent as OdnoklassnikiIcon } from '@/assets/svg/social/odnoklassniki.svg';
import { ReactComponent as TelegramIcon } from '@/assets/svg/social/telegram-share.svg';
import { ReactComponent as ViberIcon } from '@/assets/svg/social/viber-share.svg';

export const shareListItem: Array<{
  itemIcon: SvgComponent;
  link: string;
  title: string;
  text?: boolean;
}> = [
  {
    itemIcon: VkIcon,
    link: 'https://vk.com/share.php?url=',
    title: 'VK',
  },
  {
    itemIcon: FacebookIcon,
    link: 'https://www.facebook.com/sharer.php?u=',
    title: 'Facebook',
  },
  {
    itemIcon: OdnoklassnikiIcon,
    link: 'https://connect.ok.ru/offer?url=',
    title: 'OK',
  },
  {
    itemIcon: TelegramIcon,
    link: 'https://t.me/share/url?url=',
    title: 'Telegram',
  },
  {
    itemIcon: ViberIcon,
    link: 'viber://forward?text=',
    title: 'Viber',
  },
  {
    itemIcon: TwitterIcon,
    link: 'https://twitter.com/intent/tweet?url=',
    title: 'Twitter',
    text: true,
  },
];
